// extracted by mini-css-extract-plugin
module.exports = {"block":"Task_block__2lf9k","completeBtn":"Task_completeBtn__3NeA1","title":"Task_title__E-HDF","nextDate":"Task_nextDate__1Obah"};